// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"73135c0a","154":"f008252d","267":"759cc2d4","389":"8cd16fda","410":"64493f60","437":"e9cda1ce","453":"3061b11e","455":"220936b2","459":"97ac589a","540":"2a048404","885":"779f9538","899":"0e9974e0","937":"ca29ba63","974":"56b5ac79","977":"93c6b2b8"}[chunkId] + ".chunk.js";
};